import type {DriverScanResult} from "../scan-model/ScanResult.tsx";
import type {ScanContext} from "../scan-model/ScanContext.tsx";

export async function scanDrivers(ctx: ScanContext): Promise<DriverScanResult | undefined> {
    const {log, logError, api, options} = ctx
    if(options.analyseDrivers) {
        try {
            log("Scanning Driver files")
            const rawDrivers = await api.drivers().queryDrivers()
            const driverTypes = rawDrivers.map(driver => driver.driverName)
            const driverFiles = rawDrivers.reduce((prev, curr) => {
                prev[curr.driverName] = curr.files.map(file => file.fileName)
                return prev
            }, {} as Record<string, string[]>)
            log("Scanned drivers")
            return {
                driverGroups: driverTypes,
                driverGroupFiles: driverFiles
            }
        } catch(e) {
            logError("Error while scanning drivers", e)
        }
    }
}